const loading = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M8 1.75a6.25 6.25 0 1 1 0 12.5 6.25 6.25 0 0 1 0-12.5m0-1.5a7.75 7.75 0 1 0 0 15.5A7.75 7.75 0 0 0 8 .25"/><path d="M8 1.75V.25A7.75 7.75 0 0 1 15.75 8h-1.5A6.25 6.25 0 0 0 8 1.75"/></svg>',
};

export { loading as default };
